/**
 *
 * SendQuestionnaires
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import {
  Column,
  Row,
  StyledTable,
  Wrap,
} from '../../../../assets/styledAssets/grid';
import {
  accentColorPrim,
  fontColorPrim,
  fontColorSecond,
} from '../../../../assets/styledAssets/vars';
import { StyledFormField } from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import { SearchIcon } from '../../../../components/Icons/Icons.component';
import { GridColumn } from '@progress/kendo-react-grid';
import { fetchPublishedQuestionnaire } from '../../../../service/Questionnarie.service';
import { Questionnaire } from '../../../Questionnaires/questionnaires';
import { User } from '../../../../domains/app';

interface IProps {
  onCancel: () => void;
  onSave: (m: Questionnaire[]) => void;
}

const SendQuestionnaires: FunctionComponent<IProps> = ({
  onCancel,
  onSave,
}) => {
  const intl = useIntl();
  const [list, setList] = useState<Questionnaire[]>([]);
  const [filteredList, setFilteredList] = useState<Questionnaire[]>([]);

  useEffect(() => {
    fetchPublishedQuestionnaire().then((res) => {
      setList(res);
      setFilteredList(res);
    });
    // eslint-disable-next-line
  }, []);

  const filterList = (val: string) => {
    setFilteredList(
      list.filter((m) => {
        return (m.name || '').includes(val);
      }),
    );
  };

  const updateField = (dataItem: any, field: keyof User) => {
    const index = filteredList.findIndex((m) => m.id === dataItem.id);
    let newList = [...filteredList];
    newList[index] = {
      ...newList[index],
      [field]: !dataItem[field],
    };
    setFilteredList(newList);
  };

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Column xs={100}>
            <Wrap alignItems={'center'} justifyCont={'space-between'}>
              <Wrap fs={'2.4rem'} color={accentColorPrim}>
                {intl.formatMessage(messages.title)}
              </Wrap>
            </Wrap>
          </Column>
        </Row>
        <Row>
          <Wrap margin={'3rem 0'} width={'100%'}>
            <Column xs={100}>
              <StyledFormField grey>
                <Input onChange={(e) => filterList(e.value)} />
                <SearchIcon color={fontColorPrim} width={'2rem'} />
              </StyledFormField>
            </Column>
          </Wrap>
          <Column xs={100}>
            <Wrap grow={'1'} overflow={'hidden'} width={'100%'} height={'100%'}>
              <StyledTable
                selectedField="checked"
                data={filteredList}
                onSelectionChange={(e) => updateField(e.dataItem, 'checked')}
              >
                <GridColumn
                  field={'checked'}
                  width="50px"
                  headerCell={() => <div />}
                />
                <GridColumn
                  field="firstName"
                  title={intl.formatMessage(messages.name)}
                  cell={(props) => (
                    <td onClick={() => updateField(props.dataItem, 'checked')}>
                      <Wrap>{props.dataItem.name}</Wrap>
                      <Wrap color={fontColorSecond}>
                        {props.dataItem.description}
                      </Wrap>
                    </td>
                  )}
                />
              </StyledTable>
            </Wrap>
          </Column>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>

        <StyledModalAction
          accent
          onClick={() => onSave(filteredList.filter((m) => m.checked))}
        >
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(SendQuestionnaires);
